import { clientFetchIsImpersonating, clientFetchUserSettings } from '@/lib/api/client/user';
import { ImpersonationStatus, UserSettings } from '@/types/api/user';
import { UseQueryOptions } from '@tanstack/react-query';

export const QUERY_KEYS = {
  ALL: 'user',
  IS_IMPERSONATING: 'isImpersonating',
  USER_SETTINGS: 'userSettings',
};

type Queries = {
  isImpersonating: UseQueryOptions<ImpersonationStatus>;
  userSettings: UseQueryOptions<UserSettings>;
};

export const impersonationQuery: UseQueryOptions<ImpersonationStatus> = {
  queryKey: [QUERY_KEYS.ALL, QUERY_KEYS.IS_IMPERSONATING],
  queryFn: clientFetchIsImpersonating,
  refetchOnWindowFocus: false,
  refetchOnMount: false,
};

export const queries: Queries = {
  isImpersonating: impersonationQuery,
  userSettings: {
    queryKey: [QUERY_KEYS.ALL, QUERY_KEYS.USER_SETTINGS],
    queryFn: clientFetchUserSettings,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  },
};
